document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-quick-add-form]');
  if (!form) return;

  event.preventDefault();

  var button = form.querySelector('.quick-add-btn');
  if (!button || button.classList.contains('is-loading')) return;

  var label = button.querySelector('.quick-add-btn__label');
  var originalText = label ? label.textContent : '';

  button.classList.add('is-loading');
  button.setAttribute('aria-disabled', 'true');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: form.querySelector('[name="id"]').value,
      quantity: 1
    })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error(err.description || 'No se pudo agregar al carrito');
        });
      }
      return response.json();
    })
    .then(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (label) label.textContent = 'Agregado';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('.cart-count-bubble, [data-cart-count]');
          if (bubble) bubble.textContent = cart.item_count;
        })
        .catch(function () {});

      setTimeout(function () {
        button.classList.remove('is-added');
        if (label) label.textContent = originalText;
      }, 1800);
    })
    .catch(function (error) {
      button.classList.remove('is-loading');
      if (label) label.textContent = 'Error';
      setTimeout(function () {
        if (label) label.textContent = originalText;
      }, 1800);
      console.error(error);
    });
});
